import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { CalendarService } from '@components/calendar/calendar.service';
import { NgbCalendar, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { DayData } from '@components/calendar/calendar-day/calendar-day.model';
import { ObservatoryService } from '@services/services.module';
import { CalendarSelectDateService } from '@components/popup-calendar/calendar-select-date.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { APP_URLS } from '@app/constants/app-urls';

@Component({
  selector: 'app-calendarios-bloqueo',
  templateUrl: './calendarios-bloqueo.component.html',
  styleUrls: ['./calendarios-bloqueo.component.scss']
})
export class CalendariosBloqueoComponent implements OnInit, OnDestroy {

  private subscriptions: Array<Subscription> = [];
  private open = false;
  private transferList: Array<any>;
  private transferKeys: string[];
  public APP_URLS = APP_URLS;
  public dayList: DayData[];
  public userData: any;
  public dateYear: any;
  public dateMonth: any;
  public dateMonthStr;
  public fechaBloqHasta;
  public anio: string;
  public mes: string;
  public dia: string;
  public bandera = true;
  public fechaInicialReport: any;
  public fechaFinalReport: any;
  public resetoFechasFocusCalendar: Subject<void> = new Subject<void>();
  public markDisable: boolean;

  constructor(
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    public calendar: NgbCalendar,
    private observatory: ObservatoryService,
    public _calendarService: CalendarService,
    public config: NgbDatepickerConfig,
    private router: Router,
    public calendarSelectDate: CalendarSelectDateService
  ) {
    window.scrollTo(0, 0);
  }

  ngOnInit() {
    this.translate.get(this.activatedRoute.snapshot.data['title']).subscribe((res: string) => {
      this.titleService.setTitle(res);
      this.markDisable = true;
    });
    this.transferList = [
      {
        user: 'Alejandro Guede Aguiar',
        type: 'interno',
        dates: [
          '15/08/1989', '16/05/2010', '17/05/2015'
        ]
      },
      {
        user: 'Manuel Jesús Prieto Acedo',
        type: 'interno',
        dates: [
          '15/08/1989', '16/05/2010', '17/07/2015', '18/05/2015'
        ]
      },
      {
        user: 'Óscar Mateo Beltrán',
        type: 'externo',
        dates: [
          '15/08/1989', '16/05/2010', '17/05/2015'
        ]
      },
      {
        user: 'Paola Erika Lobeiras Iglesias',
        type: 'externo',
        dates: [
          '15/08/1989', '16/05/2010', '17/07/2015', '18/05/2015', '19/08/1989', '20/05/2010', '21/07/2015', '22/05/2015', '23/07/2015', '24/05/2015'
        ]
      },
      {
        user: 'Juan Félix Navarro Rivera',
        type: 'externo',
        dates: [
          '15/08/1989', '20/05/2010'
        ]
      },
      {
        user: 'José Luis Ruiz Díaz',
        type: 'externo',
        dates: [
          '15/08/1989', '20/05/2010', '30/07/2015'
        ]
      }
    ];
    this.transferKeys = ['user', 'type', 'dates', 'icon'];
  }

  // no se Usa de momento en el calendario-bloqueos, pero es para resetear  el focus
  resetear() {
    this.resetoFechasFocusCalendar.next();
  }

  routeTo(route) {
    this.router.navigate([route]);
  }

  loadLockedDates() {
    this.markDisable = false;
    setTimeout(() => {
      this.markDisable = true;
      this.observatory.setData('loader', false);
    }, 1500);
  }

  ngOnDestroy() {
    for (const subs of this.subscriptions) {
      subs.unsubscribe();
    }
  }

}
